import { useCallback } from 'react';
import { useRemoteConfig, useFeatureFlags } from '@funtech-int/yango-shared';

import { useProfileManager } from '@/shared/hooks/useProfileManager';

import { featureFlagsScheme } from '../../../lib/featureFlags';
import { getFilmPlayerConfig } from '../utils/get-film-player-config';
import { StreamHandler } from '../../feature-player/hooks/config/use-stream-handler';

export const useFilmPlayerConfigHandler: () => StreamHandler = () => {
    const remoteConfig = useRemoteConfig();
    const profileManager = useProfileManager();
    const featureFlags = useFeatureFlags(featureFlagsScheme);

    return useCallback(
        (baseInfo) => {
            if (baseInfo?.__typename === 'Film' || baseInfo?.__typename === 'Video') {
                return getFilmPlayerConfig(baseInfo, {
                    remoteConfig,
                    profileManager,
                    featureFlags,
                });
            }
            return null;
        },
        [featureFlags, profileManager, remoteConfig]
    );
};
